/**
 * 글씨 크기 관리 유틸리티
 * - 글씨 크기 설정 및 저장
 * - 기본 설정 및 UI 업데이트
 */

// 글씨 크기 설정 키
const FONT_SIZE_STORAGE_KEY = 'sns-font-size-preference';

// 가능한 글씨 크기 옵션
const FONT_SIZES = ['normal', 'large', 'larger', 'largest', 'huge'];

/**
 * 초기 글씨 크기 설정
 */
export const initFontSize = () => {
  // 저장된 글씨 크기 설정 불러오기
  const savedSize = localStorage.getItem(FONT_SIZE_STORAGE_KEY) || 'normal';
  
  // 유효한 크기인지 확인
  const validSize = FONT_SIZES.includes(savedSize) ? savedSize : 'normal';
  
  // 글씨 크기 적용
  applyFontSize(validSize);
  
  // UI 업데이트
  updateFontSizeUI(validSize);
  
  // 이벤트 리스너 설정
  setupFontSizeListeners();
};

/**
 * 글씨 크기 적용
 * @param {string} size - 글씨 크기 ('normal', 'large', 'larger', 'largest')
 */
export const applyFontSize = (size) => {
  // 기존 글씨 크기 클래스 제거
  document.body.classList.remove(...FONT_SIZES.map(s => `font-size-${s}`));
  
  // 새 글씨 크기 클래스 추가
  document.body.classList.add(`font-size-${size}`);
  
  // 로컬 스토리지에 설정 저장
  localStorage.setItem(FONT_SIZE_STORAGE_KEY, size);
};

/**
 * 글씨 크기 UI 업데이트
 * @param {string} activeSize - 현재 활성화된 크기
 */
const updateFontSizeUI = (activeSize) => {
  // 모든 글씨 크기 버튼에서 활성 클래스 제거
  document.querySelectorAll('.font-size-control .size-btn').forEach(btn => {
    btn.classList.remove('active');
  });
  
  // 활성화된 크기 버튼에 활성 클래스 추가
  const activeBtn = document.querySelector(`#font-size-${activeSize}`);
  if (activeBtn) {
    activeBtn.classList.add('active');
  }
};

/**
 * 글씨 크기 버튼 이벤트 리스너 설정
 */
const setupFontSizeListeners = () => {
  document.querySelectorAll('.font-size-control .size-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const size = btn.dataset.size;
      
      if (FONT_SIZES.includes(size)) {
        applyFontSize(size);
        updateFontSizeUI(size);
      }
    });
  });
}; 